<template>
  <div class="gift-record">
    <template v-if="list.length == 0">
      <van-empty
        class="custom-image"
        :image="emptyImgUrl"
        description="暂无数据"
        v-if="finished"
      />
      <div class="empty-block" v-else>
      </div>
    </template>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="listLoadMore"
    >
      <div v-for="(item, index) in list" :key="index">
        <record-item :item="item"></record-item>
      </div>
    </van-list>
  </div>
</template>

<script>
import RecordItem from "./components/record-item.vue";
import pic_default from "@/assets/img/car-life/pic_default.png";
import { ProductCode } from "@/common/constant";
import { carLifeOrderList } from "@/common/api";

export default {
  name: "giftRecord",
  components: {
    RecordItem,
  },

  data() {
    return {
      emptyImgUrl: pic_default,
      list: [],
      pageNum: 0,
      loading: false,
      finished: false,
    };
  },
  methods: {
    init() {
    },
    openCancelOrder() {
      this.$refs.cancelOrder.init();
    },
    async getOrderList() {
      const size = 10
      this.loading = true
      try {
        const res = await carLifeOrderList({
          pageNum: this.pageNum + 1,
          pageSize: size,
          productCategoryCodes: [ProductCode.giftCard],
          productType: 3
        })
        const list = res.list || []
        list.forEach(item => {
          const nameArr = item.productName.split('(')
          item.originProductName = nameArr[0] || ''
        })
        this.pageNum++
        if (list.length < size) {
          this.finished = true
        }
        this.list = [...this.list, ...list]
      } catch (e) {
        // err handle
      }
      this.loading = false
    },

    listLoadMore() {
      this.getOrderList()
    },
  },
  created() {
  }
};
</script>
<style>
.van-empty {
  padding: 0;
  margin-top: 1.83rem;
}

.custom-image .van-empty__image {
  width: 3.88rem;
  height: 2.44rem;
}
</style>

<style lang="scss" scoped>
.gift-record {
  background: #f4f6f7;
  width: 7.5rem;
  height: 100vh;
  font-size: 16px;
  color: #383838;
  overflow-y: auto;

  .empty-block {
    width: 3.88rem;
    height: 2.44rem;
  }
}

.bottom {
  padding-top: 12px;
  color: #c8c8c8;
  padding-bottom: 32px;
  text-align: center;
}
</style>
